import { _axios } from "../../../Utils/Axios/axios";

export const getCommentsForTeachingItemService = async (
  userToken: string,
  techingItemId: string | number
) => {
  return _axios.get(`/comment/${techingItemId}`, {
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });
};
